import React from 'react';
import { IconProps } from '.';

const SvgColoredFaceVeryGood = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#60C782'
        d='M23 12c0 6.075-4.925 11-11 11-6.074 0-11-4.925-11-11C1 5.926 5.926 1 12 1c6.075 0 11 4.926 11 11Z'
      />
      <path
        fill='#456600'
        d='M12 13.433c-1.812 0-3.014-.21-4.5-.498-.34-.065-1 0-1 .997 0 1.993 2.297 4.485 5.5 4.485 3.202 0 5.5-2.492 5.5-4.485 0-.997-.66-1.063-1-.997-1.486.288-2.688.498-4.5.498Z'
      />
      <path
        fill='#456600'
        fillRule='evenodd'
        d='M7.668 9.533a1.705 1.705 0 0 0-.332.51.9.9 0 1 1-1.672-.669c.088-.218.307-.677.712-1.094.418-.431 1.066-.847 1.957-.847.879 0 1.552.404 1.987.83.217.214.389.444.51.662.1.179.237.47.237.783a.9.9 0 0 1-1.792.125 1.182 1.182 0 0 0-.215-.284 1.027 1.027 0 0 0-.727-.316c-.282 0-.49.12-.665.3Zm7.334 0a1.707 1.707 0 0 0-.333.51.9.9 0 1 1-1.671-.669c.087-.218.307-.677.712-1.094.418-.431 1.065-.847 1.957-.847.878 0 1.551.404 1.986.83.218.214.389.444.51.662.1.178.237.47.237.783a.9.9 0 0 1-1.791.125 1.183 1.183 0 0 0-.215-.284 1.027 1.027 0 0 0-.727-.316c-.282 0-.49.12-.665.3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredFaceVeryGood;
